// import "nouislider/distribute/nouislider.min.css";
import React from 'react';
import './RangePicker.scss';
import { Typography } from "src/latest/src/components";
import SliderContainer from './sliderContainer/sliderContainer';
import { sanitiseHTML } from '../../../../../utils/helpers';

type Props = {
    exquestiondata: object,
    onValueChange: Function, 
    classname: String,
    isUsedInClientReport: Boolean,
    orientation: String,
    sliderDisabled: Boolean
 }
export default function RangePicker({ exquestiondata, onValueChange,classname = 'custom-slider-container',isUsedInClientReport = false,orientation='horizontal', sliderDisabled = false }: Props) {
    return <div className={classname}>
        {(exquestiondata.title !== 'null' && exquestiondata.title !== '' && exquestiondata.title !== undefined)  &&
            <div div={true} className= 'slider-title-container' >
                <Typography className='right-label'>{sanitiseHTML(exquestiondata.title)}</Typography>
            </div>
        }
        <div className='custom-range-picker-parent'>

            {!isUsedInClientReport && <Typography className='left-label'>{exquestiondata.metadata?.left_label}</Typography>}
            <div className={`custom-range-picker ${exquestiondata.unique_key}`} disabled={sliderDisabled}>
                <SliderContainer onValueChange={onValueChange} questionChoice={exquestiondata} sliderOrientation={orientation} />
            </div>
            {!isUsedInClientReport && <Typography className='right-label'>{exquestiondata.metadata?.right_label}</Typography>}
        </div>
    </div>;
}

// left_label, right_label
